import { useEffect, useState } from 'react';

export type InternetSpeed = 'not-verified' | 'slow' | 'normal' | 'fast';

type InternetInfo = {
  internetSpeed: InternetSpeed;
};

const useInternetInfo = (): InternetInfo => {
  const [internetSpeed, setInternetSpeed] = useState('not-verified');

  const speedChangeHandler = () => {
    const velocity = navigator?.connection.downlink || 10;
    let iSpeed: InternetSpeed = 'slow';
    if (velocity > 5) {
      iSpeed = 'fast';
    }

    if (velocity > 1) {
      iSpeed = 'normal';
    }

    setInternetSpeed(iSpeed);
  };

  useEffect(() => {
    if (!navigator?.connection) {
      setInternetSpeed('not-verified');
      return;
    }

    navigator?.connection.addEventListener('change', speedChangeHandler);

    return () => navigator?.connection.removeEventListener('change', speedChangeHandler);
  }, []);

  return {
    internetSpeed,
  };
};

export default useInternetInfo;
